import DocViewer, { DocViewerRenderers, IDocument } from '@cyntler/react-doc-viewer';
import { Document_FieldsFragment } from 'queries';

import Modal from 'common/modal';

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
  document: Document_FieldsFragment;
  onClose?: () => void;
};

type DocViewerOverrideProps = {
  document: IDocument | undefined;
  fileName: string;
};

export const CustomDocViewerNoRendererError = ({ document, fileName }: DocViewerOverrideProps) => {
  if (!fileName) {
    return <div>This file cannot be previewed. Please download it instead.</div>;
  }

  return (
    <div>
      {fileName} cannot be previewed. Please download it instead by{' '}
      <a href={document?.uri}>clicking here</a>.
    </div>
  );
};

const DocumentPreviewModal = ({ setShowModal, showModal, document, onClose }: Props) => {
  const docViewerDocumentsParam: IDocument[] = [];
  let height: string | number = 'auto';

  if (!document.isFolder) {
    docViewerDocumentsParam.push({
      fileName: document.name,
      uri: document.url,
    } as IDocument);

    const fileExtension = document.name.split('.').pop();
    if (fileExtension === 'docx' || fileExtension === 'doc' || fileExtension === 'xlsx') {
      height = 400; // any more than this and the bottom of the files get cut off within the modal
    }
  }

  return (
    <Modal
      setShowModal={setShowModal}
      showModal={showModal}
      onActionClick={undefined}
      onExitClick={() => {
        if (onClose) {
          onClose();
        }
        setShowModal(false);
      }}
      content={
        <DocViewer
          documents={docViewerDocumentsParam}
          pluginRenderers={DocViewerRenderers}
          prefetchMethod="GET"
          config={{
            noRenderer: {
              overrideComponent: CustomDocViewerNoRendererError,
            },
            pdfVerticalScrollByDefault: true,
          }}
          style={{ width: '100%', height }}
        />
      }
      title="Preview"
      cancelVerb="Close"
      actionVerb={undefined}
      loading={undefined}
      showActions={undefined}
      maxWidth="xl"
    />
  );
};

export default DocumentPreviewModal;
